import ProTable from './pro-table.vue'

import {defineColumnComponent} from './columnComponent'
import {defineColumnFormat} from './columnFormat'

import TextColumn from './columns/text-column.vue'
import ActionColumn from './columns/action-column.vue'
import EditorColumn from "./columns/editor-column.vue";
import DictColumn from "./columns/dict-column.vue";

import TableFilter from './filter/table-filter.vue'
import TextFilter from './filter/text-filter.vue'
import NumberFilter from './filter/number-filter.vue'
import DateFilter from './filter/date-filter.vue'

import numberFormat from './format/number-format'
import moneyFormat from './format/money-format'
import dateFormat from './format/date-format'
import datetimeFormat from './format/datetime-format'
import {defineColumnFilter} from './columnFilter'

import {defineAction} from './action/index'
import openDrawer from './action/open-drawer'
import command from './action/command'

import ProFormTable from "./pro-form-table.vue";

export default {

	install(Vue) {
		// console.log(Vue)
		Vue.component(ProTable.name, ProTable)
		Vue.component(ProFormTable.name, ProFormTable)
		Vue.component(TextColumn.name, TextColumn)
		Vue.component(ActionColumn.name, ActionColumn)
		Vue.component(EditorColumn.name, EditorColumn)
		Vue.component(TableFilter.name, TableFilter)
		Vue.component(TextFilter.name, TextFilter)
		Vue.component(NumberFilter.name, NumberFilter)
		Vue.component(DateFilter.name, DateFilter)
		Vue.component(DictColumn.name, DictColumn)

		//列组件注册
		defineColumnComponent('text', {
			component: TextColumn.name
		})
		defineColumnComponent('default', {
			component: TextColumn.name
		})
		defineColumnComponent('action', {
			component: ActionColumn.name
		})
		defineColumnComponent('dict', {
			component: DictColumn.name
		})
		defineColumnComponent('editor', {component: EditorColumn.name})
		//过滤器逻辑
		defineColumnFilter('text', {component: TextFilter.name, condition: 'LIKE'})
		defineColumnFilter('number', {component: NumberFilter.name, condition: 'GE,LE'})
		defineColumnFilter('date', {component: DateFilter.name, condition: 'GE,LE'})


		//过滤格式化
		defineColumnFormat(numberFormat.name, numberFormat)
		defineColumnFormat(moneyFormat.name, moneyFormat)
		defineColumnFormat(dateFormat.name, dateFormat)
		defineColumnFormat(datetimeFormat.name, datetimeFormat)

		//动作定义
		defineAction('open-drawer', openDrawer)
		defineAction('command', command)
	}
}
